var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"col-sm"},[_vm._v("\n  "+_vm._s(_vm.$t('hello'))+"\n  "),_c('br'),_vm._v("\n  "+_vm._s(_vm.$t('message'))+"\n  ")])}
var staticRenderFns = []

export { render, staticRenderFns }